import { render, staticRenderFns } from "./set-share.vue?vue&type=template&id=ae0158ee&scoped=true"
import script from "./set-share.vue?vue&type=script&lang=js"
export * from "./set-share.vue?vue&type=script&lang=js"
import style0 from "./set-share.vue?vue&type=style&index=0&id=ae0158ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0158ee",
  null
  
)

export default component.exports